import { range } from 'ramda';
import bounds from 'binary-search-bounds';

const MIN_SCALE = 20;
const MAX_SCALE = 100;
const STEP = 1;

const calculateScaleHeight = (baseWidth: number, clonedNode: HTMLElement, scale: number) => {
  clonedNode.style.width = `${Math.round(baseWidth / scale)}px`;
  clonedNode.style.transform = `scale(${scale})`;

  return clonedNode.getBoundingClientRect().height;
};

const getScaleHeight = (node: HTMLElement) => {
  const baseWidth = node.getBoundingClientRect().width;
  const clonedNode = node.cloneNode(true) as HTMLElement;

  clonedNode.style.position = 'fixed';
  clonedNode.style.visibility = 'hidden';

  document.body.appendChild(clonedNode);

  return {
    getNodeScaleHeight: (scale: number) => calculateScaleHeight(baseWidth, clonedNode, scale),
    cleanup: () => {
      document.body.removeChild(clonedNode);
    }
  };
};

type ScaleAndHeight = { scale?: number; height?: number };

export const getLargestFitScale = (node: HTMLElement, containerHeight: number) => {
  const { getNodeScaleHeight, cleanup } = getScaleHeight(node);

  const getHeight = (scaleAndHeight: ScaleAndHeight) =>
    scaleAndHeight.height ?? getNodeScaleHeight(scaleAndHeight.scale || 0);

  const scales = range(MIN_SCALE / STEP, MAX_SCALE / STEP + 1).map(
    scale => ({ scale: (scale * STEP) / MAX_SCALE } as ScaleAndHeight)
  );

  const largestFitScaleIndex = bounds.le(
    scales,
    { height: containerHeight },
    (a, b) => getHeight(a) - getHeight(b)
  );

  cleanup();

  return scales[largestFitScaleIndex]?.scale || 0;
};
